import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DevicesService } from 'src/app/_services/devices.service';
import { Product } from '../../../models/product';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize } from '@kolkov/ngx-gallery';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { UserService } from 'src/app/_services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { AddProductToShoppingCartComponent } from 'src/app/modals/add-product-to-shopping-cart/add-product-to-shopping-cart.component';
import { ProductCharacteristicsComponent } from '../product-characteristics/product-characteristics.component';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';



@Component({
  selector: 'app-product-view',
  templateUrl: './product-view.component.html',
  styleUrls: ['./product-view.component.scss']
})
export class ProductViewComponent implements OnInit {

  product: Product;

  galleryOptions: NgxGalleryOptions[];
  // galleryOptionsCell: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];

  diviceXs: boolean;
  diviceSm: boolean;

  productQuantity = 1;
  infoGessiPoints = false;

  constructor(private route: ActivatedRoute, private matDialog: MatDialog,
    private userService: UserService, private devicesService: DevicesService,
    private _bottomSheet: MatBottomSheet, private router: Router,
    private firebaseAuthService: FirebaseAuthService,) {

    // console.log('vista prod');
    this.route.data.subscribe(data => {
      this.product = data['product'];

      console.log("this.product.suggestedProducts", this.product.suggestedProducts)
      this.chargeImages();
    });

  }

  ngOnInit(): void {
    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });
  }

  chargeImages() {
    //json configuracion carrousel
    console.log("hola")
    this.galleryOptions = [
      {
        width: '100%',
        height: '450px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        imageSize: NgxGalleryImageSize.Contain
      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '300px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 20
      },
      // max-width 400
      {
        height: '250px',
        breakpoint: 400,
        preview: false,
        imageSize: NgxGalleryImageSize.Contain
      }
    ];



    //decalracion json img para carrousel
    this.galleryImages = [];
    if (this.product.photos == null) {
      this.galleryImages = [
        {
          small: '../../../../assets/caja.jpg',
          medium: '../../../../assets/caja.jpg',
          big: '../../../../assets/caja.jpg'
        }
      ];
    }
    else {

      for (let i in this.product.photos) {
        console.log(this.product.photos[i]);


        this.galleryImages.push({ small: this.product.photos[i], medium: this.product.photos[i], big: this.product.photos[i] });
      }

    }
  }

  openBottomSheet(characteristics) {
    this._bottomSheet.open(ProductCharacteristicsComponent, {
      data: characteristics, panelClass: 'characteristicsContent'
    });
  }

  async addToCar(product: Product) {
    product.quantity = this.productQuantity;

    if (this.firebaseAuthService.publicUser) {
      console.log(this.firebaseAuthService);
      console.log('logueado');
      await this.userService.addProductToShoppingCart(product);
    } else {
      console.log('sin loguearse');
      this.userService.addProductToShoppingCartInLocalStorage(product);
    }

    if (this.diviceXs || this.diviceSm) {
      const dialogRef = this.matDialog.open(AddProductToShoppingCartComponent,
        {
          height: 'auto',
          width: '95%',
          data: {
            product: product,
            quanty: product.quantity
          }
        });
    }
    else {
      const dialogRef = this.matDialog.open(AddProductToShoppingCartComponent,
        {
          height: 'auto',
          width: '60%',
          data: {
            product: product,
            quanty: product.quantity
          }
        });
    }
  }

  async goToRelatedProduct(productId: string) {
    this.router.navigate([{ outlets: { primary: ['product', productId], sidebar: ['product', productId] } }]);
  }

}
